import { render } from "./LeapSecondsModal.vue?vue&type=template&id=6a18e51b&scoped=true"
import script from "./LeapSecondsModal.vue?vue&type=script&lang=js"
export * from "./LeapSecondsModal.vue?vue&type=script&lang=js"

import "./LeapSecondsModal.vue?vue&type=style&index=0&id=6a18e51b&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a18e51b"]])

export default __exports__